__turbopack_context__.v({
  "categoryLink": "_6BWmJa_categoryLink",
  "categoryTitle": "_6BWmJa_categoryTitle",
  "container": "_6BWmJa_container",
  "featuredSolutions": "_6BWmJa_featuredSolutions",
  "fullWidthOnMobile": "_6BWmJa_fullWidthOnMobile",
  "galleryItem": "_6BWmJa_galleryItem",
  "galleryItemContent": "_6BWmJa_galleryItemContent",
  "galleryItemImage": "_6BWmJa_galleryItemImage",
  "galleryItemText": "_6BWmJa_galleryItemText",
  "productCard": "_6BWmJa_productCard",
  "productImage": "_6BWmJa_productImage",
  "productName": "_6BWmJa_productName",
  "productNameContainer": "_6BWmJa_productNameContainer",
  "products": "_6BWmJa_products",
  "productsContainer": "_6BWmJa_productsContainer",
  "productsSection": "_6BWmJa_productsSection",
  "sectionHeader": "_6BWmJa_sectionHeader",
  "templatesContainer": "_6BWmJa_templatesContainer",
});
